// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginAlert_container__3LbJ4","userIcon":"LoginAlert_userIcon__2NK7m","iconContainer":"LoginAlert_iconContainer__3M10B","calendarIcon":"LoginAlert_calendarIcon__1Wz0b"};